<template>
    <div class="bgColorImg">
        <div class="bgColorImgBox">
            <div class="table">
                <div>背景颜色</div>
                <div>背景图片</div>
            </div>
            <div class="table-content">
                <div>
                    <color :colorObj="bgColorImg"></color>
                </div>
                <div class="avatar-uploader">
                    <i class="iconfont ooicon-error-fill" @click="removeUrl" v-if="bgColorImg.url"></i>
                    <el-upload  action="" :show-file-list="false" :http-request="uploadAvatar">
                        <img v-if="bgColorImg.url" :src="bgColorImg.url" class="avatar" size="small" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import color from '@/components/decoration/common/color.vue';
import { upload } from '@/utils/request.js';
import { UPLOAD_PATH } from '@/utils/constant.js';

export default {
    components: { color },
    data(){
        return{

        }
    },
    props:{
        bgColorImg:{
            type: Object,
            default: {}
        }
    },
    methods:{
        removeUrl(){
            this.bgColorImg.url = "";
        },

        //上传缩略图
        uploadAvatar(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.bgColorImg.url = res.url;
                }
            });
        },
    }
}
</script>

<style scoped lang="scss">
.bgColorImgBox{
    width: 100%;
    padding: 10px;
    margin-top: 10px;
    background-color: #f2f2f2;
    border-radius: 7px;

    .table{
        width: 100%;
        height: 35px;
        display: flex;

        div{
            flex: 1;
            height: 100%;
            border-radius: 7px;
            background-color: #eeeeee;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .table-content{
        width: 100%;
        height: 100px;
        display: flex;

        div{
            flex: 1;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.avatar-uploader{
    position: relative;

    .ooicon-error-fill{
        position: absolute;
        right: 35px;
        top: -5px;
        font-size: 28px;
        color: #000;
        z-index: 100;
    }

    img{
        width: 100%;
        height: 100%;
    }
}

</style>